import { Component } from '@angular/core';
import BaseIndexPageConfig from '../../../../../components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from '../../../../../components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from '../../../../../components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from '../../../../../services/api/api-options.config';
import { ItemProductsService } from '../../../../../services/api/general-settings/item-products.service';
import { RouteService } from '../../../../../services/route.service';
import { CustomerService } from '../../../../../services/api/customer.service';
import { BaseIndexPageComponent } from '../../../../../components/pages/base-index-page/base-index-page.component';

@Component({
  selector: 'app-customers-client-types-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './customers-client-types-index-page.component.html',
  styleUrl: './customers-client-types-index-page.component.scss'
})
export class CustomersClientTypesIndexPageComponent {
list: any[] = [];

  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected customersService: CustomerService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Client Types',
      cardTitle: 'Manage Client Types',
      addNewItemButton: {
        type: 'success',
        title: 'Add Client Types',
        onClick: () => {
          this.routeService.customerSettingsClientTypesCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          // new DataTableColumnText({
          //   attribute: 'Id',
          //   header: 'ID',
          //   filter: 'text',
          //   value: (item: any) => {
          //     return item.customerTypeId;
          //   }
          // }),
          new DataTableColumnText({
            attribute: 'Code',
            header: 'Code',
            filter: 'text',
            value: (item: any) => {
              return item.code;
            }
          }),
          new DataTableColumnText({
            attribute: 'Name',
            header: 'Name',
            filter: 'text',
            value: (item: any) => {
              return item.name;
            }
          }),          
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            width: '50px',
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View clientType details',
                onClick: (item: any) => {
                  this.routeService.customerSettingsClientTypesDetail(item.customerTypeId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit clientType',
                onClick: (item: any) => {
                  this.routeService.customerSettingsClientTypesUpdate(item.customerTypeId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete clientType',
                onClick: (item: any) => {
                  this.baseIndexPageConfig.dataTable.data = this.baseIndexPageConfig.dataTable.data.filter((clientTypes: any) => clientTypes.customerTypeId !== item.customerTypeId);
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.customersService.listSettingsClientsTypes(options),
      responseListModelName: 'customerTypes',
    }
  }
}
